import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getCalendarData,
  getTruIdStatus,
  getLeaveDetails,
  getLeaveStatusData,
  getTeamDetailData,
  submitRegularisation,
  regularisationHistory,
  submitLeave,
  uploadRegularisationFileWithPresignedUrl,
  uploadLeaveFileWithPresignedUrl,
  getFilteredTeamData,
  getTeamDetailManagerData,
  getManagerReportDownload,
  getDashboardOverview,
} from "../../store/AttendanceSlice/thunk";
import { attendanceActions } from "../../store/AttendanceSlice";
import { addDays } from "date-fns";
import { getAllReportees } from "../../store/RequestSlice/thunk";
import ClockIcon from "../../assets/icons/scheduleclock_orange.svg";
import OverTimeIcon from "../../assets/icons//hourglass.svg";
import TeamIcon from "../../assets/icons//groups.svg";
import LeaveIcon from "../../assets/icons/sailing_white.svg";
import SickIcon from "../../assets/images/leave_images/sick_leave.png";
import CasualIcon from "../../assets/images/leave_images/casual_leave.png";
import PrivilegeIcon from "../../assets/images/leave_images/privilage_leave.png";
import MaternityIcon from "../../assets/images/leave_images/maternity : paternity_leave.png";
import MenstrualIcon from "../../assets/images/leave_images/menstrual_leave.png";
import EarnedIcon from "../../assets/images/leave_images/earned_leave.png";
import ESICIcon from "../../assets/images/leave_images/ESIC_leave.png";
import MiscarriageIcon from "../../assets/images/leave_images/miscarriage_leave.png";
import SuccessImg from "../../assets/images/successimg.png";
import RegSuccessImg from "../../assets/images/success.png";
import AttendanceCalendar from "../../components/AttendanceCalendar";
import CommonModal from "../../commonComponents/CommonModal";
import NothingIcon from "../../assets/images/task-not-found-1 6.png";
import LeaveApproval from "../../components/LeaveApproval";
import Regularisation from "../../components/Regularisation";
import RegularisationHistory from "../../components/RegularisationHistory";
import RegularisationApproval from "../../components/RegularisationApproval";
import ApplyLeave from "../../components/ApplyLeave";
import InitialsCircle from "../../components/InitialsCircle";
import LeaveHistory from "../../components/LeaveHistory";
import ManagerTeamView from "../../components/ManagerTeamView";
import moment from "moment";
import "./Attendance.css";
import AttendanceTimer from "../../components/AttendanceTimer";
import CustomTooltip from "../../commonComponents/CustomToolTip";
import { OverviewLoader } from "../../utils/skeleton";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";

const Attendance = () => {
  // refs , constants
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const openLeaveModalRef = useRef();
  const closeLeaveModalRef = useRef();
  const openLeaveHistoryModalRef = useRef();
  const closeLeaveHistoryModalRef = useRef();
  const openRegularisationModalRef = useRef();
  const closeRegularisationModalRef = useRef();
  const openRegularisationHistoryModalRef = useRef();
  const closeRegularisationHistoryModalRef = useRef();
  const openManagerTeamViewRef = useRef();
  const closeManagerTeamViewRef = useRef();
  const openModalForEmpRef = useRef();
  const closeModalForEmpRef = useRef();
  const openSucessRef = useRef();
  const closeSucessRef = useRef();
  const openRegSucessRef = useRef();
  const closeRegSucessRef = useRef();
  const openCancelRef = useRef();
  const closeCancelRef = useRef();
  const minDate = new Date(new Date().setDate(new Date().getDate() - 15));
  const maxDate = new Date(new Date().setDate(new Date().getDate() + 60));
  const LIMIT = 2000;
  const MANAGER_LIMIT = 20;

  // local states
  const [isApproval, setIsApproval] = useState(false);
  const [isRegularisationApproval, setIsRegularisationApproval] =
    useState(false);
  const [leaveTypeSelected, setLeaveTypeSelected] = useState(null);
  const [reason, setReason] = useState("");
  const [employeeType, setEmployeeType] = useState("");
  const [dateSelected, setDateSelected] = useState([
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  ]);
  const [managerTeamList, setManagerTeamList] = useState([]);
  const [managerOffset, setManagerOffset] = useState(0);
  const [managerHasMore, setManagerHasMore] = useState(true);
  const [isManagerViewOpen, setIsManagerViewOpen] = useState(false);
  const lastFiltersRef = useRef(null);
  const managerObserverRef = useRef();
  const managerViewRequestedRef = useRef(false);
  const [filters, setFilters] = useState({
    search_term: "",
    designation: "",
    status: "",
    start_date: moment(new Date()).startOf("month").format("DD-MM-YY"),
    end_date: moment(new Date()).format("DD-MM-YY"),
    store: "",
  });
  const [leaveToCancel, setLeaveToCancel] = useState({});
  const [isLeaveSubmitInvalid, setIsLeaveSubmitInvalid] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isResponsiveScreen, setIsResponsiveScreen] = useState(false);

  // redux states
  const employeeID = useSelector((state) => state.auth.employeeID);
  const calendarDataResponse = useSelector(
    (state) => state.attendance.calendarDataResponse,
  );
  const role = useSelector(
    (state) => state?.attendance?.dashboardOverviewResponse?.permission || "",
  );
  const token = useSelector((state) => state?.auth?.accessToken || "");
  const teamDetailDataResponse = useSelector(
    (state) => state.attendance.teamDetailDataResponse,
  );
  const regularisationPayload = useSelector(
    (state) => state.attendance.regularisationPayload,
  );
  const regularisationFileUploadResponseStatus = useSelector(
    (state) => state.attendance.regularisationFileUploadResponseStatus,
  );
  const submitRegularisationResponseStatus = useSelector(
    (state) => state.attendance.submitRegularisationResponseStatus,
  );
  const leaveDataResponse = useSelector(
    (state) => state.attendance.leaveDataResponse || {},
  );
  const leaveDataResponseStatus = useSelector(
    (state) => state.attendance.leaveDataResponseStatus,
  );
  const leaveFormData = useSelector((state) => state.attendance.leaveData);
  const halfMode = useSelector((state) => state.attendance.halfMode);
  const leaveFileUploadResponseStatus = useSelector(
    (state) => state.attendance.leaveFileUploadResponseStatus,
  );
  const submitLeaveResponseStatus = useSelector(
    (state) => state.attendance.submitLeaveResponseStatus,
  );
  const leaveDetailResponse = useSelector(
    (state) => state.attendance.leaveDetailResponse,
  );
  const leaveDetailResponseStatus = useSelector(
    (state) => state.attendance.leaveDetailResponseStatus,
  );
  const filteredTeamDataResponse = useSelector(
    (state) => state.attendance.filteredTeamDataResponse,
  );
  const getAllReporteesResponse = useSelector(
    (state) => state.request.getAllReporteesResponse,
  );
  const teamDetailManagerDataResponse = useSelector(
    (state) => state.attendance.teamDetailManagerDataResponse,
  );
  const teamDetailManagerDataResponseStatus = useSelector(
    (state) => state.attendance.teamDetailManagerDataResponseStatus,
  );
  const dashboardOverviewResponse = useSelector(
    (state) => state.attendance.dashboardOverviewResponse,
  );
  const dashboardOverviewResponseStatus = useSelector(
    (state) => state.attendance.dashboardOverviewResponseStatus,
  );
  const totalDays = useSelector(
    (state) => state.attendance.leaveCountResponse?.total_count,
  );
  const truIdStatusResponse = useSelector(
    (state) => state.attendance.truIdStatusResponse,
  );
  const teamPreviewLimit = isResponsiveScreen ? 1 : 3;

  // API CALLS
  const getManagerTeamData = useCallback(
    (startOffset = 0, currentFilters = filters) => {
      lastFiltersRef.current = JSON.stringify(currentFilters); // Record the last set of filters used
      dispatch(
        getTeamDetailManagerData({
          employee_id: employeeID,
          designation: currentFilters.designation,
          store: currentFilters.store || "",
          start_date: currentFilters.start_date,
          end_date: currentFilters.end_date,
          status: currentFilters.status,
          search_term: currentFilters.search_term,
          length: MANAGER_LIMIT.toString(),
          start: startOffset.toString(),
          file: false,
        }),
      );
    },
    [dispatch, employeeID, filters, MANAGER_LIMIT],
  );

  const downloadReport = useCallback(async () => {
    try {
      const totalCount =
        teamDetailManagerDataResponse?.total_count || MANAGER_LIMIT.toString();
      const response = await dispatch(
        getManagerReportDownload({
          employee_id: employeeID,
          designation: filters.designation,
          store: filters.store || "",
          start_date: filters.start_date,
          end_date: filters.end_date,
          status: filters.status,
          search_term: filters.search_term,
          length: totalCount.toString(),
          start: "0",
          file: true,
        }),
      ).unwrap();

      if (response?.body?.file_url) {
        window.open(response.body.file_url, "_blank");
      }
    } catch (error) {
      console.error("Failed to download report:", error);
    }
  }, [dispatch, employeeID, filters, teamDetailManagerDataResponse]);

  // USEEFFECTS

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const updateResponsiveState = (event) => {
      setIsResponsiveScreen(event.matches);
    };

    setIsResponsiveScreen(mediaQuery.matches);
    mediaQuery.addEventListener("change", updateResponsiveState);
    dispatch(getTruIdStatus({ employee_id: employeeID }));

    return () => {
      mediaQuery.removeEventListener("change", updateResponsiveState);
    };
  }, []);

  useEffect(() => {
    dispatch(
      getFilteredTeamData({
        employee_id: employeeID,
      }),
    );
    dispatch(getAllReportees({ offset: 0, limit: LIMIT }));
    getCalendarDetails();
    loadEmployeeOverview();

    const modalElement = document.getElementById("managerteamviewModal");
    const handleModalClose = () => {
      setIsManagerViewOpen(false);
      lastFiltersRef.current = null;
      setFilters({
        search_term: "",
        designation: "",
        status: "",
        start_date: moment(new Date()).format("DD-MM-YY"),
        end_date: moment(new Date()).format("DD-MM-YY"),
        store: "",
      });
    };
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleModalClose);
    }

    return () => {
      dispatch(attendanceActions.setInitialState());
      dispatch(attendanceActions.resetSubmitLeaveResponse());
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isManagerViewOpen) return;

    const currentFiltersStr = JSON.stringify(filters);
    if (lastFiltersRef.current === currentFiltersStr) return;

    const timeoutId = setTimeout(() => {
      setManagerTeamList([]);
      setManagerOffset(0);
      setManagerHasMore(true);
      getManagerTeamData(0);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [filters, isManagerViewOpen, getManagerTeamData]);

  // API data handling
  useEffect(() => {
    if (
      teamDetailManagerDataResponseStatus === "SUCCESS" &&
      teamDetailManagerDataResponse?.body
    ) {
      const newEmployees = teamDetailManagerDataResponse.body;
      if (newEmployees.length > 0) {
        if (managerOffset === 0) {
          setManagerTeamList(newEmployees);
          if (
            managerViewRequestedRef.current &&
            !isManagerViewOpen &&
            openManagerTeamViewRef.current
          ) {
            managerViewRequestedRef.current = false;
          }
        } else {
          setManagerTeamList((prev) => [...prev, ...newEmployees]);
        }
        setManagerHasMore(newEmployees.length >= MANAGER_LIMIT);
      } else {
        if (managerOffset === 0) {
          setManagerTeamList([]);
          if (
            managerViewRequestedRef.current &&
            !isManagerViewOpen &&
            openManagerTeamViewRef.current
          ) {
            openManagerTeamViewRef.current.click();
            setIsManagerViewOpen(true);
            managerViewRequestedRef.current = false;
          }
        }
        setManagerHasMore(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    teamDetailManagerDataResponse,
    teamDetailManagerDataResponseStatus,
    managerOffset,
  ]);

  useEffect(() => {
    if (regularisationFileUploadResponseStatus === "SUCCESS") {
      onSubmitRegularisation();
    }
    if (regularisationFileUploadResponseStatus === "ERROR") {
      if (closeRegularisationModalRef.current) {
        closeRegularisationModalRef.current.click();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regularisationFileUploadResponseStatus]);

  useEffect(() => {
    if (leaveDetailResponseStatus === "SUCCESS") {
      dispatch(attendanceActions.resetLeaveDetailStatus());
    }
    if (leaveDetailResponseStatus === "ERROR") {
      if (closeLeaveHistoryModalRef.current) {
        closeLeaveHistoryModalRef.current.click();
      }
      dispatch(attendanceActions.resetLeaveDetailStatus());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaveDetailResponseStatus]);

  useEffect(() => {
    if (submitRegularisationResponseStatus === "SUCCESS") {
      if (closeRegularisationModalRef.current) {
        closeRegularisationModalRef.current.click();
      }
      openRegSucessRef.current.click();
      dispatch(attendanceActions.setRegularisationPayload({}));
    } else if (submitRegularisationResponseStatus === "ERROR") {
      if (closeRegularisationModalRef.current) {
        closeRegularisationModalRef.current.click();
      }
    }
  }, [submitRegularisationResponseStatus]);

  useEffect(() => {
    if (leaveFileUploadResponseStatus === "SUCCESS") {
      onSubmitLeave();
    }
    if (leaveFileUploadResponseStatus === "ERROR") {
      if (closeLeaveModalRef.current) {
        closeLeaveModalRef.current.click();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaveFileUploadResponseStatus]);

  useEffect(() => {
    if (submitLeaveResponseStatus === "SUCCESS") {
      if (closeLeaveModalRef.current) {
        closeLeaveModalRef.current.click();
        closeLeaveHistoryModalRef.current.click();
        closeCancelRef.current.click();
      }
      if (!leaveToCancel?.leave_id) {
        openSucessRef.current.click();
      }
      resetLeave();
    } else if (submitLeaveResponseStatus === "ERROR") {
      if (closeLeaveModalRef.current) {
        closeLeaveModalRef.current.click();
        closeLeaveHistoryModalRef.current.click();
        closeCancelRef.current.click();
      }
      resetLeave();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitLeaveResponseStatus]);

  useEffect(() => {
    if (leaveDataResponse?.employee_type)
      setEmployeeType(leaveDataResponse?.employee_type);
  }, [leaveDataResponse]);

  useEffect(() => {
    if (!isEdit) {
      dispatch(
        attendanceActions.setLeaveData({
          ...leaveFormData,
          leaveType: leaveTypeSelected,
          start: "",
          end: "",
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaveTypeSelected, isEdit]);

  useEffect(() => {
    if (dateSelected[0] && dateSelected[1]) {
      dispatch(
        getCalendarData({
          employee_id: employeeID,
          start_date: moment(dateSelected[0]).format("DD-MM-YY") || "",
          end_date: moment(dateSelected[1]).format("DD-MM-YY") || "",
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateSelected]);

  // Common functions
  const loadMoreTeamMembers = useCallback(() => {
    if (teamDetailManagerDataResponseStatus === "PENDING" || !managerHasMore)
      return;
    const newOffset = managerOffset + MANAGER_LIMIT;
    setManagerOffset(newOffset);
    getManagerTeamData(newOffset);
  }, [
    managerOffset,
    teamDetailManagerDataResponseStatus,
    managerHasMore,
    getManagerTeamData,
    MANAGER_LIMIT,
  ]);

  const lastTeamElementRef = useCallback(
    (node) => {
      if (teamDetailManagerDataResponseStatus === "PENDING") return;
      if (managerObserverRef.current) managerObserverRef.current.disconnect();
      managerObserverRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && managerHasMore) {
            loadMoreTeamMembers();
          }
        },
        { threshold: 0.1 },
      );
      if (node) managerObserverRef.current.observe(node);
    },
    [teamDetailManagerDataResponseStatus, managerHasMore, loadMoreTeamMembers],
  );

  const onStartDateChange = (date) => {
    if (leaveTypeSelected?.leave_type === "Maternity") {
      const maternityBalance = leaveDataResponse?.body?.find(
        (type) => type?.leave_type === "Maternity",
      );
      if (maternityBalance) {
        dispatch(
          attendanceActions.setLeaveData({
            ...leaveFormData,
            start: date,
            end: addDays(
              new Date(date),
              Number(maternityBalance?.balance_leave) - 1,
            ),
            applied_days: maternityBalance?.balance_leave,
          }),
        );
      }
    } else if (leaveTypeSelected?.leave_type === "Paternity") {
      const paternityBalance = leaveDataResponse?.body?.find(
        (type) => type?.leave_type === "Paternity",
      );

      dispatch(
        attendanceActions.setLeaveData({
          ...leaveFormData,
          start: date,
          end: addDays(
            new Date(date),
            Number(paternityBalance?.balance_leave) - 1,
          ),
          applied_days: paternityBalance?.balance_leave,
        }),
      );
    } else if (leaveTypeSelected?.leave_type === "Miscarriage") {
      const miscarriageBalance = leaveDataResponse?.body?.find(
        (type) => type?.leave_type === "Miscarriage",
      );
      dispatch(
        attendanceActions.setLeaveData({
          ...leaveFormData,
          start: date,
          end: addDays(
            new Date(date),
            Number(miscarriageBalance?.balance_leave) - 1,
          ),
          applied_days: miscarriageBalance?.balance_leave,
        }),
      );
    }
  };

  const resetLeave = () => {
    dispatch(attendanceActions.setLeaveData({}));
    setLeaveToCancel({});
    setLeaveTypeSelected(null);
    setIsEdit(false);
    dispatch(attendanceActions.setHalfMode(false));
    dispatch(attendanceActions.resetLeaveCount());
    setReason("");
    setErrorText("");
    setIsLeaveSubmitInvalid(false);
  };

  // Calendar API

  const getCalendarDetails = () => {
    dispatch(
      getCalendarData({
        employee_id: employeeID,
        start_date: moment(dateSelected[0]).format("DD-MM-YY") || "",
        end_date: moment(dateSelected[1]).format("DD-MM-YY") || "",
      }),
    );
  };

  const loadEmployeeOverview = () => {
    dispatch(
      getDashboardOverview({
        token,
        employee_id: employeeID,
        source: "web",
        device_id: "web",
        device_name: "web",
        logoutAll: false,
      }),
    );
  };

  // TEAM FUNCTIONS

  const getTeamData = () => {
    dispatch(
      getTeamDetailData({
        employee_id: employeeID,
      }),
    );
  };

  // Regularisation FUNCTIONS
  const getRegularisationHistory = () => {
    dispatch(regularisationHistory({ employee_id: employeeID }));
  };

  const uploadRegularisationFile = (type) => {
    dispatch(
      uploadRegularisationFileWithPresignedUrl({
        filename: regularisationPayload?.file?.name,
        employee_id: String(employeeID),
      }),
    );
  };
  const onSubmitRegularisation = () => {
    dispatch(attendanceActions.resetFileUploadStatus());
    let payload = {
      filename: regularisationPayload?.file?.name,
      employee_id: String(employeeID),
      clock_in: regularisationPayload?.punchInTime,
      clock_out: regularisationPayload?.punchOutTime,
      date: moment(regularisationPayload?.punchInDate).format("DD-MM-YY"),
      clock_out_date: moment(regularisationPayload?.punchOutDate).format(
        "DD-MM-YY",
      ),
      reason: regularisationPayload?.reason,
      employee_comment: regularisationPayload?.comment
        ? regularisationPayload?.comment
        : "",
    };

    dispatch(submitRegularisation(payload));
  };
  const getLeaveData = () => {
    dispatch(getLeaveStatusData({ employee_id: employeeID }));
  };

  // LEAVE FUNCTIONS
  const getRemainingLeaves = () => {
    dispatch(
      getLeaveDetails({
        employee_id: employeeID,
      }),
    );
  };
  const handleDateSelect = (data) => {
    dispatch(attendanceActions.setLeaveData({ ...leaveFormData, ...data }));
  };

  const uploadLeaveAttachmentFile = () => {
    setIsLeaveSubmitInvalid(false);
    setErrorText("");
    let totalCalculatedDays = halfMode
      ? leaveFormData?.applied_days
      : totalDays;
    if (
      !leaveFormData?.file?.name &&
      leaveFormData?.leaveType?.leave_type === "SL" &&
      totalCalculatedDays > 3
    ) {
      setIsLeaveSubmitInvalid(true);
      setErrorText("Attachment is mandatory for Sick Leave more than 3 days");
      return;
    }
    if (leaveFormData?.file) {
      dispatch(
        uploadLeaveFileWithPresignedUrl({
          filename: leaveFormData?.file?.name,
          employee_id: String(employeeID),
        }),
      );
    } else {
      onSubmitLeave();
    }
  };
  const calculateTotalDays = (start, end) => {
    return moment(end).diff(start, "days") + 1;
  };

  const applyLeaveValidations = (payload) => {
    const mandatoryFields = [
      "employee_id",
      "employee_type",
      "reason",
      "start_date",
      "end_date",
      "leave_type",
    ];

    if (halfMode && payload?.applied_days % 1 === 0.5) {
      mandatoryFields.push("half_day", "half_day_date");
    }
    const missingKey = mandatoryFields?.find((key) => {
      const value = payload[key];

      const isInvalidDate =
        (value instanceof Date && isNaN(value.getTime())) ||
        value === "Invalid date";

      return (
        value === undefined ||
        value === null ||
        value === "" ||
        (typeof value === "number" && isNaN(value)) ||
        isInvalidDate
      );
    });

    if (missingKey) {
      return {
        status: false,
        msg: `Missing ${missingKey} field. Please fill all the mandatory fields.`,
      };
    }

    if (
      !leaveFormData?.file &&
      (leaveFormData?.leaveType?.leave_type === "Maternity" ||
        leaveFormData?.leaveType?.leave_type === "Paternity")
    ) {
      return { status: false, msg: "Attachment is mandatory." };
    } else if (
      halfMode &&
      payload?.applied_days % 1 === 0.5 &&
      !payload?.half_day
    ) {
      return { status: false, msg: "Please select half type you are taking." };
    } else {
      return { status: true };
    }
  };

  const onSubmitLeave = () => {
    setIsLeaveSubmitInvalid(false);
    setErrorText("");
    let payload = {
      employee_id: employeeID,
      employee_type: employeeType,
      leave_type: leaveTypeSelected?.leave_type,
      start_date: moment(leaveFormData?.start).format("DD-MM-YY"),
      end_date: moment(leaveFormData?.end).format("DD-MM-YY"),
      applied_days: totalDays
        ? Number(totalDays)
        : calculateTotalDays(leaveFormData?.start, leaveFormData?.end),
      reason: reason,
      filename: leaveFormData?.file?.name || "",
    };
    if (halfMode && leaveFormData?.applied_days % 1 === 0.5) {
      payload.applied_days =
        leaveFormData?.end === leaveFormData?.start
          ? totalDays
          : totalDays - 0.5;
      payload.half_day = leaveFormData?.halfDaysSelected;
      payload.half_day_date =
        leaveFormData?.halfDaysSelected?.first_half === "present"
          ? moment(leaveFormData?.end).format("DD-MM-YY")
          : moment(leaveFormData?.start).format("DD-MM-YY");
    }
    let isInvalid = applyLeaveValidations(payload);
    if (!isInvalid?.status) {
      setIsLeaveSubmitInvalid(true);
      setErrorText(isInvalid?.msg);
      return;
    }
    if (payload.applied_days <= 0) {
      setIsLeaveSubmitInvalid(true);
      setErrorText(
        "Total days cannot be zero or negative ( Total days calculated based on working days betweeen the dates selected) ",
      );
      return;
    }
    console.log("====================================");
    console.log("payload", payload);
    console.log("====================================");
    dispatch(submitLeave(payload));
  };

  const onCancelLeave = (leaveData) => {
    let payload = {
      employee_id: leaveData?.employee_id,
      employee_type: employeeType,
      leave_type: leaveData?.leave_type,
      start_date: moment(new Date(leaveData?.start_date)).format("DD-MM-YY"),
      end_date: moment(new Date(leaveData?.end_date)).format("DD-MM-YY"),
      applied_days: leaveData?.applied_days,
      reason: leaveData?.leave_remarks,
      filename: leaveData?.filename || "",
      leave_id: leaveData?.leave_id,
      cancel: true,
    };
    dispatch(submitLeave(payload));
  };

  const onEditLeave = (leaveData) => {
    setIsEdit(true);
    let payload = {
      leaveType: {
        leave_type: "SL",
      },
      start: new Date(leaveData?.start_date),
      end: new Date(leaveData?.end_date),
      applied_days: leaveData?.applied_days,
    };
    if (leaveData?.filename) {
      payload.file = { name: leaveData?.filename };
    }
    dispatch(attendanceActions.setLeaveData(payload));
    setLeaveTypeSelected({
      leave_type: "SL",
    });
    setReason(leaveData?.leave_remarks);
    getRemainingLeaves();
    closeLeaveHistoryModalRef.current.click();
    openLeaveModalRef.current.click();
  };

  const getLeaveIcon = (type) => {
    switch (type) {
      case "Sick Leave":
      case "SL":
        return SickIcon;
      case "Casual Leave":
      case "CL":
        return CasualIcon;
      case "Privilege Leave":
      case "PL":
        return PrivilegeIcon;
      case "Maternity":
      case "Maternity Leave":
      case "Paternity":
      case "Paternity Leave":
        return MaternityIcon;
      case "Menstrual":
      case "Menstrual Leave":
        return MenstrualIcon;
      case "Miscarriage":
      case "Miscarriage Leave":
        return MiscarriageIcon;
      case "Reserved PL":
      case "RPL":
        return EarnedIcon;
      case "ESIC":
        return ESICIcon;
      default:
        return CasualIcon;
    }
  };

  // HOOKS
  const TeamModalForEmp = () => (
    <div className="team-modal">
      <div className="flex items-center">
        <div className="team-md-header">team</div>
        <div className="team-md-ondate-wrap">
          <div className="team-md-ondate-text">Today</div>
        </div>
      </div>
      <div className="flex mt-12">
        <div className="onwork-box">
          <div className="box-header">working</div>
          {teamDetailDataResponse?.body?.working.map((item, index) => (
            <div key={index} className="flex items-center">
              <InitialsCircle fullName={item?.full_name} size={28} />

              <div className="onwork-name">{item?.full_name}</div>
            </div>
          ))}
          {!teamDetailDataResponse?.body?.working?.length && (
            <div className="flex flex-col items-center justify-center h-full w-full">
              <img className="rp-empty-ico" src={NothingIcon} alt="" />
              <div className="rp-empty-text">No data available</div>
            </div>
          )}
        </div>
        <div className="onleave-box">
          <div className="box-header">on leave</div>
          {teamDetailDataResponse?.body?.on_leave.map((item, index) => (
            <div className="flex items-center w-full">
              <InitialsCircle fullName={item?.full_name} size={28} />
              <div key={index} className="onleave-name">
                {item.full_name}
              </div>
              <div
                className="onleave-date-wrap"
                style={{ paddingLeft: item.leave_type ? "8px" : "32px" }}
              >
                {item.leave_type && (
                  <img
                    src={getLeaveIcon(item.leave_type)}
                    className="onleave-icon"
                    alt={item.leave_type}
                  />
                )}
                <div className="onleave-date">{`Until ${moment(item.end_date).format("DD MMM 'YY")}`}</div>
              </div>
            </div>
          ))}
          {!teamDetailDataResponse?.body?.on_leave?.length && (
            <div className="flex flex-col items-center justify-center h-full w-full">
              <img className="rp-empty-ico" src={NothingIcon} alt="" />
              <div className="rp-empty-text">No data available</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const SuccessPopup = () => (
    <div className="att-succ-pop">
      <img className="att-succ-img" src={SuccessImg} alt="" />
      <div className="att-succ-text">“sent for approval”</div>
      <div className="att-succ-subtext">
        Your leave application have been sent for approval. Enjoy your
        well-deserved fun!
      </div>
    </div>
  );
  const RegularisationSuccessPopup = () => (
    <div className="att-succ-pop">
      <img className="att-succ-img" src={RegSuccessImg} alt="reg" />
      <div className="att-succ-text">“sent for approval”</div>
      <div className="att-succ-subtext">
        Your regularisation application have been sent for approval.
      </div>
    </div>
  );

  const CancelPopup = () => (
    <div className="att-cancel-pop">
      <div className="att-cancel-text">
        Are you sure you want to delete the applied leave ?
      </div>
      <div className="att-cancel-btn-grp">
        <div
          className="rp-approval-card-action-btn rp-approve"
          onClick={() => onCancelLeave(leaveToCancel)}
        >
          <span
            style={{ fontSize: "12px", color: "white" }}
            class="material-symbols-rounded"
          >
            done_all
          </span>
          {submitLeaveResponseStatus === "PENDING" ? "Deleting..." : "Yes"}
        </div>

        <div
          className="rp-approval-card-action-btn rp-reject"
          onClick={() => closeCancelRef.current.click()}
        >
          <span
            style={{ fontSize: "12px", color: "white" }}
            class="material-symbols-rounded"
          >
            close
          </span>
          No
        </div>
      </div>
    </div>
  );

  return isApproval ? (
    isRegularisationApproval ? (
      <RegularisationApproval
        changeStatus={() => {
          setIsApproval(false);
          setIsRegularisationApproval(false);
        }}
      />
    ) : (
      <LeaveApproval
        changeStatus={() => {
          setIsApproval(false);
          setIsRegularisationApproval(false);
        }}
      />
    )
  ) : (
    <div className="att-home">
      <div className="flex items-center mb-4">
        <button
          type="button"
          aria-label="Back to all modules"
          className="xl:hidden mr-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
          onClick={() => navigate("../all")}
        >
          <img src={ArrowbackIcon} alt="Back" className="h-5 w-5" />
        </button>
        <div className="att-header mb-0 font-semibold">overview</div>
      </div>
      {dashboardOverviewResponseStatus === "PENDING" && <OverviewLoader />}
      {dashboardOverviewResponseStatus === "SUCCESS" && (
        <div className="att-usr-content">
          <AttendanceTimer
            className="att-card-timer"
            overViewresponse={dashboardOverviewResponse}
            // clockInTime={
            //   dashboardOverviewResponse?.attendance_details?.clock_in
            // }
            // clockOutTime={
            //   dashboardOverviewResponse?.attendance_details?.clock_out
            // }
            // shiftHour={
            //   dashboardOverviewResponse?.attendance_details?.total_work_hours
            // }
            // leaveType={
            //   dashboardOverviewResponse?.attendance_details?.is_on_leave
            //     ? dashboardOverviewResponse?.attendance_details?.leave_type
            //     : ""
            // }
          />
          <div className="att-duration att-card-duration">
            {/* <div className="duration-ico-wrap"> */}
            <img className="duration-ico" src={ClockIcon} alt="" />
            {/* </div> */}
            <div className="duration-text">required work duration</div>
            <div className="duration-hour">
              {dashboardOverviewResponse?.attendance_details?.total_work_hours}h
            </div>
          </div>
          <div className="att-overtime att-card-overtime">
            <CustomTooltip
              position="bottom"
              text={"compoff text"}
              content={
                <div className="flex flex-col">
                  <div>
                    Expiring soon :{" "}
                    {dashboardOverviewResponse?.compoff_details?.next_expiry
                      ? moment(
                          new Date(
                            dashboardOverviewResponse?.compoff_details
                              ?.next_expiry,
                          ),
                        ).format("DD'MMM")
                      : "N/A"}
                  </div>
                  <div>
                    Total Credited :{" "}
                    {dashboardOverviewResponse?.compoff_details?.total_credit ||
                      0}
                  </div>
                </div>
              }
            >
              <>
                <div className="flex items-center">
                  <div className="ovr-ico-wrap">
                    <img className="ovr-ico" src={OverTimeIcon} alt="" />
                  </div>
                  <div className="ovr-text">comp off</div>
                </div>
                <div className="ovr-contents">
                  <div className="ovr-balance">
                    <div className="ovr-content-text">Balance</div>
                    <div className="ovr-content-value ovr-green">
                      {dashboardOverviewResponse?.compoff_details?.balance || 0}
                    </div>
                  </div>
                  <div className="ovr-values">
                    <div className="ovr-content-text">Used</div>
                    <div className="ovr-content-value">
                      {dashboardOverviewResponse?.compoff_details
                        ?.total_debit || 0}
                    </div>
                  </div>
                  <div className="ovr-values">
                    <div className="ovr-content-text">Expired</div>
                    <div className="ovr-content-value ovr-red">
                      {dashboardOverviewResponse?.compoff_details
                        ?.expired_count || 0}
                    </div>
                  </div>
                </div>
              </>
            </CustomTooltip>
          </div>
          <div className="att-team att-card-team">
            <div className="flex w-full">
              <div className="team-ico-wrap">
                <img className="team-ico" src={TeamIcon} alt="" />
              </div>
              <div className="team-txt">team</div>
              <div
                className="team-view-btn"
                onClick={() => {
                  if (role === "Manager") {
                    setManagerTeamList([]);
                    setManagerOffset(0);
                    setManagerHasMore(true);
                    managerViewRequestedRef.current = true;
                    getManagerTeamData(0);
                    openManagerTeamViewRef.current.click();
                    setIsManagerViewOpen(true);
                  } else {
                    openModalForEmpRef.current.click();
                    getTeamData();
                  }
                }}
              >
                View
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div className="team-working">
                <div className="work-text">Working</div>
                <div className="work-list">
                  {dashboardOverviewResponse?.team_details?.working_members
                    ?.slice(0, teamPreviewLimit)
                    ?.map((member) => (
                      <InitialsCircle fullName={member?.full_name} size={24} />
                    ))}
                  <div className="work-count-wrap">
                    <div className="work-count-text">
                      {dashboardOverviewResponse?.team_details?.working_count >
                      teamPreviewLimit
                        ? `+${dashboardOverviewResponse?.team_details?.working_count - teamPreviewLimit}`
                        : (dashboardOverviewResponse?.team_details
                            ?.working_count ?? 0)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="team-onleave">
                <div className="work-text">On Leave</div>
                <div className="work-list">
                  {dashboardOverviewResponse?.team_details?.leave_members
                    ?.slice(0, teamPreviewLimit)
                    ?.map((member) => (
                      <InitialsCircle fullName={member?.full_name} size={24} />
                    ))}
                  <div className="work-count-wrap">
                    <div className="work-count-text">
                      {" "}
                      {dashboardOverviewResponse?.team_details?.leave_count >
                      teamPreviewLimit
                        ? `+${dashboardOverviewResponse?.team_details?.leave_count - teamPreviewLimit}`
                        : (dashboardOverviewResponse?.team_details
                            ?.leave_count ?? 0)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="att-leaves att-card-leaves">
            <div className="flex w-full">
              <div className="leave-ico-wrap">
                <img className="leave-ico" src={LeaveIcon} alt="" />
              </div>
              <div className="team-txt">leaves</div>
            </div>
            <div className="flex flex-col w-full">
              <div className="leave-available">
                <div className="work-text">Available</div>
                <div className="flex items-center ml-auto">
                  <div className="available-count">
                    {dashboardOverviewResponse?.leave_details
                      ? parseFloat(
                          Object.entries(
                            dashboardOverviewResponse.leave_details,
                          )
                            .filter(
                              ([key]) =>
                                key !== "taken" && key !== "taken_leaves",
                            )
                            .reduce(
                              (sum, [, value]) => sum + Number(value || 0),
                              0,
                            )
                            .toFixed(2),
                        )
                      : 0}
                  </div>
                  <div
                    className="apply-btn-wrap"
                    onClick={() => {
                      openLeaveModalRef.current.click();
                      getRemainingLeaves();
                    }}
                  >
                    <div className="apply-btn-text">Apply</div>
                  </div>
                </div>
              </div>
              <div className="leave-taken">
                <div className="work-text">Taken</div>
                <div className="flex items-center ml-auto">
                  <div className="taken-count">
                    {dashboardOverviewResponse?.leave_details?.taken !==
                    undefined
                      ? Number(
                          dashboardOverviewResponse.leave_details.taken || 0,
                        ).toFixed(2)
                      : "0.00"}
                  </div>
                  <div
                    className="history-btn-wrap"
                    onClick={() => {
                      getLeaveData();
                      openLeaveHistoryModalRef.current.click();
                    }}
                  >
                    <div className="history-btn-text">History</div>
                  </div>
                </div>
              </div>
              {role === "Manager" && (
                <div className="leave-taken">
                  <div className="work-text">Approvals</div>
                  <div className="flex items-center ml-auto">
                    <div className="history-btn-wrap">
                      <div
                        className="history-btn-text"
                        onClick={() => {
                          setIsApproval(true);
                          setIsRegularisationApproval(false);
                        }}
                      >
                        View
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="att-calendar">
        <div className="att-head">calendar</div>
        <AttendanceCalendar
          calendarData={calendarDataResponse?.body}
          calendarBanner={truIdStatusResponse}
          onOpenRegularisationModal={() =>
            openRegularisationModalRef.current?.click()
          }
          onOpenRegularisationHistoryModal={() => {
            openRegularisationHistoryModalRef.current?.click();
            getRegularisationHistory();
          }}
          onOpenRegularisationHistoryNavChange={() => {
            setIsApproval(true);
            setIsRegularisationApproval(true);
          }}
          onMonthChange={(date) => {
            if (date?.start && date?.end) {
              setDateSelected([date?.start, date?.end]);
            }
          }}
          role={role}
        />
      </div>

      {/* MODALS / POPUP'S */}
      <CommonModal
        openRef={openLeaveModalRef}
        closeRef={closeLeaveModalRef}
        id="leaveModal"
        outSideCloseButton={true}
        hideCloseButton={true}
        backDrop={false}
        content={
          <ApplyLeave
            leaveDataResponseStatus={leaveDataResponseStatus}
            leaveDataResponse={leaveDataResponse}
            leaveTypeSelected={leaveTypeSelected}
            setLeaveTypeSelected={setLeaveTypeSelected}
            minDate={minDate}
            maxDate={maxDate}
            handleDateSelect={handleDateSelect}
            leaveFormData={leaveFormData}
            reason={reason}
            setReason={setReason}
            onSubmitLeave={uploadLeaveAttachmentFile}
            onFileChange={(file) => {
              dispatch(attendanceActions.setLeaveFile(file));
            }}
            onStartChange={onStartDateChange}
            getLeaveIcon={getLeaveIcon}
            isLeaveSubmitInvalid={isLeaveSubmitInvalid}
            errorText={errorText}
            submitLeaveResponseStatus={submitLeaveResponseStatus}
          />
        }
        disabled={false}
        size="md"
        modalStyle={{
          maxWidth: "440px",
          width: "100%",
          backgroundColor: "transparent",
          marginBottom: "30px",
          borderRadius: "24px",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
        onModalClose={() => {
          resetLeave();
          dispatch(attendanceActions.resetSubmitLeaveResponse());
        }}
      />

      <CommonModal
        openRef={openLeaveHistoryModalRef}
        closeRef={closeLeaveHistoryModalRef}
        id="leavehistoryModal"
        outSideCloseButton={true}
        hideCloseButton={true}
        backDrop={false}
        content={
          <LeaveHistory
            leaveDetailResponse={leaveDetailResponse}
            onCancelLeave={(leaveSelected) => {
              setLeaveToCancel(leaveSelected);
              openCancelRef.current.click();
            }}
            onEditLeave={onEditLeave}
          />
        }
        disabled={false}
        size="xl"
        modalStyle={{
          minWidth: "1000px",
          backgroundColor: "transparent",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />

      <CommonModal
        openRef={openRegularisationModalRef}
        closeRef={closeRegularisationModalRef}
        id="regularisationModal"
        outSideCloseButton={true}
        hideCloseButton={true}
        backDrop={false}
        content={
          <Regularisation
            key={resetKey}
            onSubmitRegularisation={() => uploadRegularisationFile()}
            maxDate={new Date()}
            minDate={
              new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate() - 7,
              )
            }
            regularisationFileUploadResponseStatus={
              regularisationFileUploadResponseStatus
            }
            submitRegularisationResponseStatus={
              submitRegularisationResponseStatus
            }
          />
        }
        disabled={false}
        size="xl"
        modalStyle={{
          // background: "#fff",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.1)",
          width: "896px",
          minHeight: "542px",
          backgroundColor: "transparent",
          borderRadius: "24px",
          border: "none",
          marginLeft: "11%",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
        onModalClose={() => {
          dispatch(attendanceActions.setRegularisationPayload({}));
          setResetKey((prev) => prev + 1);
        }}
      />

      <CommonModal
        openRef={openRegularisationHistoryModalRef}
        closeRef={closeRegularisationHistoryModalRef}
        id="regularisationhistoryModal"
        outSideCloseButton={true}
        hideCloseButton={true}
        backDrop={false}
        content={<RegularisationHistory />}
        disabled={false}
        size="xl"
        modalStyle={{
          // background: "#fff",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.1)",
          backgroundColor: "transparent",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />

      <CommonModal
        openRef={openManagerTeamViewRef}
        closeRef={closeManagerTeamViewRef}
        id="managerteamviewModal"
        outSideCloseButton={true}
        hideCloseButton={true}
        backDrop={false}
        content={
          isManagerViewOpen && (
            <ManagerTeamView
              filteredTeamDataResponse={filteredTeamDataResponse}
              getAllReporteesResponse={getAllReporteesResponse}
              teamDetailManagerDataResponse={teamDetailManagerDataResponse}
              managerTeamList={managerTeamList}
              lastTeamElementRef={lastTeamElementRef}
              teamDetailManagerDataResponseStatus={
                teamDetailManagerDataResponseStatus
              }
              filters={filters}
              setFilters={setFilters}
              downloadReport={downloadReport}
            />
          )
        }
        disabled={false}
        size="xl"
        modalStyle={{
          background: "#fff",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.1)",
          maxHeight: "92vh",
          height: "auto",
          backgroundColor: "transparent",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />

      <CommonModal
        openRef={openModalForEmpRef}
        closeRef={closeModalForEmpRef}
        id="teamModalForEmp"
        outSideCloseButton={true}
        hideCloseButton={true}
        content={<TeamModalForEmp />}
        disabled={false}
        backDrop={false}
        size="lg"
        modalStyle={{
          // background: "#fff",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.1)",
          width: "760px",
          minHeight: "560px",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />

      <CommonModal
        openRef={openSucessRef}
        closeRef={closeSucessRef}
        id="sucesspopup"
        outSideCloseButton={true}
        hideCloseButton={true}
        content={<SuccessPopup />}
        disabled={false}
        backDrop={false}
        size="sm"
        modalStyle={{
          borderRadius: "24px",
          // background: "#FFF",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.10)",
          height: "312px",
          width: "420px",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />
      <CommonModal
        openRef={openRegSucessRef}
        closeRef={closeRegSucessRef}
        id="regsucesspopup"
        outSideCloseButton={true}
        hideCloseButton={true}
        content={<RegularisationSuccessPopup />}
        disabled={false}
        backDrop={false}
        size="sm"
        modalStyle={{
          borderRadius: "24px",
          // background: "#FFF",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.10)",
          height: "312px",
          width: "420px",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
        onModalClose={() => {
          dispatch(attendanceActions.resetSubmitRegularisationResponse({}));
        }}
      />

      <CommonModal
        openRef={openCancelRef}
        closeRef={closeCancelRef}
        id="cancelpopup"
        outSideCloseButton={true}
        hideCloseButton={true}
        content={<CancelPopup />}
        disabled={false}
        backDrop={false}
        size="sm"
        modalStyle={{
          borderRadius: "24px",
          // background: "#FFF",
          // boxShadow: "0 4px 40px 0 rgba(23, 33, 40, 0.10)",
          height: "auto",
          width: "420px",
          border: "none",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />
    </div>
  );
};
export default Attendance;
